<template>
    <div v-show="visible">
        <label>
            {{ t(displayName) }}
        </label>
        <textarea type="text" v-model="value" class="controls form-control search-component"
                  @input="onInput"></textarea>
    </div>
</template>

<script>

import DateRangePickerPl from "@/components/DateRangePickerPl.vue";
import moment from "moment";
import {FILTER_DATE_FORMAT} from "@/const";
import DateFormatter from "@/Models/DateFormatter.ts";

export default {
    components: {DateRangePickerPl},
    props: {
        config: {
            type: Object,
            default: () => {
                return {
                    name: null,
                    value: null,
                    display: true,
                    position: 0,
                    visible: true,
                    displayName: null
                };
            }
        },
        eventBus: {
            Type: Object,
        },
        queryParams: {
            Type: Object
        },
        routeParams: {
            Type: Object
        },
        onChange: {
            Type: Function,
        },
        onDefaultValueSet: {
            Type: Function,
        },
    },
    data() {
        return {
            displayName: null,
            visible: true,
            value: null,
            minDate: null,
            maxDate: null,
            name: null,
        };
    },
    mounted() {
        this.init();
        this.$parent.$on(`${this.name}-set-value`, (filterState) => {
            this.setValue(filterState);
        });
        this.setDefaultValue(this.queryParams[this.name] || this.config.value);
    },
    computed: {
    },
    methods: {
        init() {
            this.displayName = this.config.displayName;
            this.visible = this.config.visible;
            this.minDate = this.config.minDate;
            this.maxDate = this.config.maxDate;
            this.name = this.config.name;
        },
        onInput() {
            this.onChange(this.name, this.value);
        },
        setDefaultValue(value) {
            if (!value) {
                return;
            }

            this.setValue(value);
            this.onDefaultValueSet(this.name, this.value);
        },
        setValue(value) {
            this.value = value;
        }
    }
}

</script>

<style scoped>
.search-component {
    resize: none!important;
    overflow: auto;
    border-color: rgb(222,222,222);
    border-radius: 5px;
    max-height: 43px;
}
</style>


// WEBPACK FOOTER //
// SearchComponent.vue?0523c60c